<template>
  <div class="c-base-modal">
    <div class="c-base-modal__wrapper">
      <button @click="close" type="button" class="c-base-modal__close">
        <base-icon width="26" height="26" name="painel/close-icon" />
      </button>
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      globalTagHTML: null,
    }
  },
  methods: {
    close() {
      this.$emit('modalState', false)
    },
  },
}
</script>

<style lang="scss">
.c-base-modal {
  @include position(fixed, 0, 0, 0, 0);
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 203;
  background-color: $overlay;

  &__wrapper {
    @include position(absolute, 0, 0, 0, 0);
    margin: 0 auto;
    width: 100%;
    max-height: 100%;
    overflow-y: auto;
    background-color: $white;
    @media (min-width: $tablet) {
      @include position(absolute, 50%, 0, auto, 0, -50%);
      max-width: 420px;
    }
  }

  &__close {
    @include position(absolute, 1em, 1em, auto, auto);
    border: 0;
    z-index: 10;
    cursor: pointer;
    color: $gray-5;
    background-color: transparent;
    padding: 0;
    outline: none;
    &:hover {
      color: $gray-7;
    }
  }
}
</style>
